import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-5 md:my-16 mt-8" }
const _hoisted_2 = {
  id: "header",
  class: "col-span-12 md:col-span-9 flex flex-col gap-5"
}
const _hoisted_3 = { class: "flex justify-between gap-3 items-center" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "flex items-center gap-5 flex-wrap" }
const _hoisted_6 = { class: "p-5" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center gap-5 flex-wrap p-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Keywords = _resolveComponent("Keywords")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Analisar palavras chaves",
              en: "Analyze keywords",
            })), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "btn-outline p-button-sm h-10",
            label: _ctx.$t('labels.cancel'),
            onClick: _ctx.confirmModal
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            class: "btn-primary p-button-sm h-10",
            label: _ctx.$t('labels.save'),
            type: "submit",
            onClick: _ctx.submit
          }, null, 8, ["label", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Capítulo:", en: "Chapter:" })), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.course?.chapter), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Objetivo:", en: "Objective:" })), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.course?.objective), 1)
        ])
      ])
    ]),
    _createVNode(_component_InfiniteScroll, { class: "col-span-12 md:col-span-9" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Clique para remover as palavras-chaves geradas",
                en: "Click to remove generated keywords",
              })), 1)
        ])
      ]),
      content: _withCtx(() => [
        (!_ctx.loader && _ctx.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "content",
                  class: "select-none",
                  key: i
                }, [
                  _createVNode(_component_Keywords, {
                    selected: _ctx.selected,
                    "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
                    item: item,
                    onOnSelect: _ctx.selectKeyword
                  }, null, 8, ["selected", "item", "onOnSelect"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_EmptyData, {
          data: (!_ctx.data || _ctx.data.length === 0) && !_ctx.loader,
          title: _ctx.emptyState.title,
          label: _ctx.emptyState.description,
          image: _ctx.emptyState.image,
          imgSize: "h-40"
        }, null, 8, ["data", "title", "label", "image"]),
        _createVNode(_component_Loader, {
          loader: _ctx.loader,
          loaderSize: "h-full"
        }, null, 8, ["loader"])
      ]),
      _: 1
    }),
    _createVNode(_component_ConfirmDialog)
  ]))
}